"use client";

import { motion } from "framer-motion";

const skillsData = [
  { title: "Data Engineering, MLOps & Cloud", items: "Hadoop, PySpark, Databricks, Big Data Analytics, Git, Docker, Kubernetes, Jenkins (CI/CD), Airflow (workflow scheduler), MLflow, AWS EC2, S3, Lambda, ECR, ECS, EKS, API Gateway, ELB, Bedrock, SageMaker" },
  { title: "Data Analysis, Statistics & Visualization", items: "EDA, Data Cleaning & Preprocessing, Outlier Detection, Correlation Analysis, Data Normalization & Scaling, Data Wrangling, Linear Algebra, Vector Spaces, Matrix Operations, Calculus, Probability, Statistics, Bayesian Methods, Hypothesis Testing, Statistical Inference, Pandas, NumPy, Matplotlib, Seaborn" },
  { title: "Generative AI & AI Systems", items: "Generative AI, LLMs, Prompt Engineering, Few- and Zero-Shot Learning, Fine-Tuning, Pretraining, Hugging Face, LangChain, LangGraph, RAG, Vector Search, Knowledge Graphs, Multi-Agent Orchestration, MCP, Streaming, Checkpointing, Model Guardrails" },
  { title: "NLP & Computer Vision", items: "BOW, TF-IDF, Word2Vec, NER, CRF, POS Tagging, Dependency Parsing, Tokenization, Masking, NLTK, spaCy, Gensim, OpenCV, Custom Object Detection and Tracking (YOLO V5), MediaPipe, OCR" },
  { title: "Machine Learning", items: "Regression, Decision Trees, Ensemble Methods, SVM, Naive Bayes, Dimensionality Reduction, RFE, Regularization, Hyperparameter Tuning, Cross-validation, Model Evaluation, Predictive Modeling, Time Series Analysis" },
  { title: "Programming, Databases & Developer Tools", items: "Python, Golang, MySQL, PostgreSQL, Flask, FastAPI, Jupyter Notebook, Visual Studio Code, PyCharm, Jira, Confluence" },
  { title: "Deep Learning", items: "ANN, CNN, RNN, LSTM, BiLSTM, GRU, Transfer Learning, Attention Mechanism, Transformers, TensorFlow, Keras, PyTorch" },
];

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

function Skills() {
  return (
    <section
      id="skills"
      name="skills"
      className="bg-skills min-h-screen bg-gray-100 text-gray-800 px-6 py-16">
      {/* <div className="max-w-6xl mx-auto text-center"> */}
      <div className="site-container text-center">
        <h2 className="text-2xl sm:text-3xl font-bold title-color mb-6">
          <u>Skills</u>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 text-left">
          {skillsData.map(({ title, items }, index) => (
            <motion.div
              key={title}
              className="block h-full p-5 tile-color"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ y: -3 }}
            >
              <h3 className="text-lg font-semibold text-blue-800 mb-2">{title}</h3>
              <p className="text-gray-700 text-sm">{items}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;